import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const CTASection = () => {
  return (
    <section className="py-24 bg-white" data-testid="cta-section">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold text-slate-800 mb-6">Ready to Start Your Journey?</h2>
        <p className="text-lg text-slate-600 mb-10">
          Join thousands of women and girls who are building better futures through NokMechik.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link to="/register">
            <Button size="lg" className="bg-terracotta hover:bg-terracotta/90 text-white rounded-full px-10 py-6 text-lg" data-testid="cta-register-btn">
              Create Free Account
            </Button>
          </Link>
          <Link to="/login">
            <Button size="lg" variant="outline" className="rounded-full px-10 py-6 text-lg border-2" data-testid="cta-login-btn">
              Sign In
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
